
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12719',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12719",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.479",
  "data-fetching-client": "static-1.9771",
  "foundations-components": "static-1.8144",
  "foundations-components-legacy": "static-1.1169",
  "foundations-theming": "static-1.4538",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8128",
  "hub-http-shared-msw-handlers": "static-1.10230",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11584",
  "I18n": "static-7.1637",
  "jasmine-runner": "static-1.6567",
  "marketplace-storefront-base": "static-1.12782",
  "quartz": "static-1.7165",
  "react-dlb": "static-1.81",
  "react-rhumb": "static-1.16792",
  "reactive-variable-buffer-atom": "static-1.2966",
  "reporting-testing-lib": "static-1.9929",
  "settings-ui-lib": "static-1.12629",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7333",
  "ui-addon-i18n": "static-1.11257",
  "ui-addon-react-router-dom": "static-1.9646",
  "unified-auth": "static-1.621",
  "unified-auth-core-lib": "static-1.903",
  "usage-tracker": "static-1.7457",
  "usage-tracker-core": "static-1.7307",
  "customer-data-property-utils": "static-1.8203",
  "hub-http": "static-1.6331",
  "integrations-lib": "static-1.16509",
  "marketplace-ui-common": "static-1.20142",
  "property-management-iframe": "static-1.13533",
  "quartz-config": "static-1.943",
  "quartz-core": "static-1.6384",
  "quartz-routing": "static-1.595",
  "quick-fetch": "static-1.3997",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4764",
  "ts-schema": "static-1.4159",
  "ui-universal-auth": "static-1.9107",
  "UIComponents": "static-3.8530",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3477",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3442",
  "quartz-webpack": "static-1.3389",
  "bend-plugin-quartz-routing": "static-1.243",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4413",
  "floating-ui": "static-1.57",
  "foundations-assets": "static-1.4982",
  "foundations-theming-specialty": "static-1.2254",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9530",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.35",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5421",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.489",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2185",
  "ui-fonts": "static-1.846",
  "ui-images": "static-2.1180",
  "bend-plugin-foundations-theming": "static-1.3021",
  "foundations-theming-base": "static-1.3523",
  "stylex": "static-1.34",
  "HeadJS": "static-2.768",
  "hs-test-utils-bend-plugin": "static-1.3239",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4434",
  "ai-components-ui-library": "static-1.9226",
  "ai-rendering-library": "static-1.10560",
  "chirp-fetch": "static-1.1995",
  "connections-embed-lib": "static-1.1195",
  "copilot-toolkit": "static-1.11414",
  "feedback-loader": "static-1.29499",
  "laboratory-lib": "static-3.7261",
  "marketplace-embed": "static-1.22439",
  "marketplace-ui-details": "static-1.10037",
  "marketplace-ui-reviews": "static-1.20097",
  "marketplace-ui-tracking": "static-1.14312",
  "sanitize-text": "static-1.8253",
  "ui-addon-video-player": "static-1.8811",
  "usage-tracker-multi": "static-1.5871",
  "usage-tracker-session-replay": "static-1.5143",
  "wootric-nps": "static-1.7062",
  "quartz-head": "static-1.830",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4760",
  "immer": "static-1.33",
  "immerable": "static-1.4259",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2564",
  "reporting-data": "static-1.67996",
  "cssUtils": "static-1.823",
  "flux-actions": "static-1.345",
  "HubStyle": "static-2.11891",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10316",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10471",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7447",
  "icons": "static-2.653",
  "marketplace-ui-apps-core": "static-1.18674",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4620",
  "foundations-components-test-utils": "static-1.5627",
  "quartz-i18n": "static-1.840",
  "react-input-autosize": "static-2.17",
  "ads-unified-auth-lib": "static-1.352",
  "google-sheets-integration-lib": "static-1.559",
  "microsoft-drive-integration-lib": "static-1.697",
  "surveymonkey-integration-lib": "static-1.24",
  "slack-ui-library": "static-1.10503",
  "fsm": "static-1.3837",
  "customer-data-objects": "static-1.7788",
  "property-translator": "static-1.5505",
  "hs-locale-management": "static-1.161",
  "frontend-preferences-client": "static-1.8036",
  "hs-promise-utils": "static-1.5700",
  "hubspot-apollo-client": "static-1.4986",
  "integrations-error-boundary-lib": "static-1.13924",
  "integrations-tracking-lib": "static-1.5715",
  "native-integrations-shared-strings": "static-1.7891",
  "reselect": "static-2.16",
  "sanitize": "static-1.4584",
  "superstore": "static-1.4868",
  "ui-shepherd-react": "static-3.10337",
  "ai-settings-ui-library": "static-1.8057",
  "hub-http-janus": "static-1.844",
  "hubspotter-http": "static-1.4731",
  "immutable-less": "static-1.4761",
  "marketplace-ui-client-types": "static-1.17549",
  "nav-meta": "static-1.29919",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18142",
  "inbound-db-properties-service-client": "static-1.3925",
  "property-management-common": "static-1.5821",
  "ui-addon-iframeable": "static-1.9174",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.543",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.840",
  "quartz-test": "static-1.840",
  "quartz-tracking": "static-1.544",
  "trellis-components": "static-1.2204",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.174",
  "bender-build-tools": "static-1.3281",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21810",
  "ContentUtils": "static-1.68673",
  "customer-data-objects-ui-components": "static-1.13139",
  "sassPrefix": "static-1.158",
  "breeze-engine-core": "static-1.371",
  "breeze-onboarding-components": "static-1.233",
  "avatar-components": "static-1.2606",
  "customer-data-filters-ui": "static-1.40161",
  "customer-data-reference-ui-components": "static-1.13281",
  "embedded-academy-lib": "static-1.14713",
  "ExportDialog": "static-6.10488",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41576",
  "reporting-snowflake": "static-1.56614",
  "reporting-ui-components": "static-2.65267",
  "reporting-visualizations": "static-1.60072",
  "trellis-theming": "static-1.1049",
  "ui-addon-teams": "static-1.21691",
  "integrations-reconnect-lib": "static-1.168",
  "magpie-lib": "static-1.5623",
  "navigation-components": "static-1.18282",
  "breeze-engine-lib": "static-1.1093",
  "magpie-types": "static-1.5083",
  "simple-logging-lib": "static-1.3158",
  "ai-studio-lib": "static-1.11934",
  "app-governance-lib": "static-1.1899",
  "developer-experience-shared-components": "static-1.10622",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8115",
  "ui-product-approvals": "static-1.28590",
  "ui-tool-access": "static-1.10256",
  "usage-based-billing-components-lib": "static-1.9393",
  "usage-tracker-anonymous": "static-1.5874",
  "usage-tracker-public": "static-1.7268",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3666",
  "persist-promise": "static-1.3808",
  "reference-resolvers": "static-1.8282",
  "ui-extensibility-client-types": "static-1.4033",
  "hubspot-apollo-cache": "static-1.445",
  "universal-page-editor-lib": "static-1.3126",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3085",
  "atom": "static-1.5183",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6078",
  "salesImages": "static-1.527",
  "batch-promise": "static-1.1651",
  "crm-component-utils": "static-1.39373",
  "crm-properties-common-lib": "static-1.5997",
  "customer-data-properties": "static-1.51955",
  "framework-data-schema-resolvers": "static-1.7001",
  "property-value-citations": "static-1.2569",
  "reference-resolvers-lite": "static-1.8207",
  "ui-business-units-lib": "static-1.9172",
  "navigation-messaging": "static-1.7609",
  "hubspotter-http-shared-msw-handlers": "static-1.10228",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4923",
  "content-icons-ui": "static-1.2257",
  "customer-data-ui-utilities": "static-1.9934",
  "conversations-skeleton-state": "static-1.7356",
  "crm-message-bus": "static-1.43270",
  "customer-data-filters-ui-msw-helpers": "static-1.22596",
  "events-data-lib": "static-1.340",
  "FormUrlGenerator": "static-2.4830",
  "framework-builder-read-service-client": "static-1.4084",
  "framework-data-schema-quick-fetch": "static-1.6906",
  "multi-account-reference-resolvers": "static-1.1091",
  "onboarding-tours": "static-1.16803",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13992",
  "academy-common-lib": "static-1.14173",
  "content-assistance-lib": "static-1.7924",
  "dashboard-lib": "static-1.81957",
  "file-manager-components": "static-1.23916",
  "getting-started-shared-tasks": "static-1.18717",
  "hubspot-prosemirror": "static-1.18537",
  "hubspot-prosemirror-plugins": "static-1.18529",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20018",
  "share-with-third-party-component-lib": "static-1.8814",
  "ui-addon-draggable": "static-3.4868",
  "ui-asset-management-lib": "static-1.11171",
  "user-context": "static-1.5218",
  "growth-payments-core": "static-1.25703",
  "reporting-plugins": "static-1.10498",
  "reporting-reports": "static-1.67674",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.834",
  "nest": "static-1.341",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10736",
  "framework-listing-lib": "static-2.29004",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30972",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4362",
  "react-dnd-compat": "static-1.4724",
  "ui-product-approvals-common": "static-1.485",
  "onboarding-scopes": "static-1.6569",
  "onboarding-tours-client": "static-1.5017",
  "platform-infra-nav-components": "static-1.7752",
  "subscription-experience-data-types": "static-1.15059",
  "crm-record-cards-service-types": "static-1.3669",
  "location-customization-utils-lib": "static-1.9582",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6081",
  "signup-constants": "static-1.19103",
  "signup-ui-url-generator": "static-2.8166",
  "card-properties-lib": "static-1.44525",
  "commerce-subscription-lib": "static-1.37392",
  "crm-actions": "static-1.6448",
  "crm-cards-sdk": "static-1.43909",
  "customer-data-properties-shared-msw-handlers": "static-1.9557",
  "customer-data-tracking": "static-1.6997",
  "hs-resources": "static-1.281",
  "pulse": "static-1.704",
  "calling-global-api": "static-1.64890",
  "calling-internal-common": "static-1.31418",
  "calling-lifecycle-internal": "static-1.66272",
  "calling-lifecycle-messages": "static-1.58566",
  "commerce-products-lib": "static-1.9957",
  "conditional-properties-service-client": "static-1.3875",
  "crm-links": "static-1.6416",
  "crm-pipelines-api-client-types": "static-1.4217",
  "external-options-client-types": "static-1.4208",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4296",
  "meetings-icalendar-utils-lib": "static-1.742",
  "multi-currency-client-types": "static-1.3770",
  "object-builder-ui-client": "static-1.49123",
  "pipeline-validation-client-types": "static-1.4046",
  "smart-property-lib": "static-1.7761",
  "tiered-pricing": "static-1.1497",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11098",
  "fdsr-migration-layer": "static-1.120",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1149",
  "growth-data-modal": "static-1.5599",
  "growth-onboarding-confetti": "static-1.3174",
  "growth-onboarding-next-action-utils": "static-1.2238",
  "onboarding-tours-utils": "static-1.869",
  "ui-shepherd-tracker": "static-1.7718",
  "academy-service-client": "static-1.3792",
  "SafeStorage": "static-1.4508",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39415",
  "FileManagerLib": "static-1.39556",
  "video-embed": "static-1.36124",
  "ui-coaching-tips": "static-1.28864",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11632",
  "video-data-lib": "static-1.35290",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8559",
  "payment-link-components": "static-1.23814",
  "ui-addon-emoji-picker": "static-1.9995",
  "EmailSignatureEditor": "static-1.24611",
  "viral-links-lib": "static-1.7178",
  "data-token-picker": "static-1.16597",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.331",
  "timezone-utils": "static-2.5351",
  "seat-types-lib": "static-1.266",
  "getting-started-shared-tasks-store": "static-1.17835",
  "ui-addon-opt": "static-4.8470",
  "campaign-roi-lib": "static-1.9421",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25667",
  "framework-data-table": "static-2.12162",
  "marketing-platform-lib": "static-1.6974",
  "nudge-client-utils": "static-1.2806",
  "nudge-custom-ui-functions": "static-1.1216",
  "switchboard-lib": "static-1.332",
  "app-users-service-client": "static-1.5716",
  "app-users-service-types": "static-1.5124",
  "mini-checkout-client": "static-1.27074",
  "onboarding-utils": "static-1.5467",
  "permissions-shared-i18n-strings-fe": "static-1.2061",
  "ui-coaching-tips-shared-config": "static-1.28849",
  "edison-service-client-types": "static-1.498",
  "crm_data": "static-4.92307",
  "customer-data-sidebar": "static-2.46316",
  "enrichment-properties-lib": "static-1.16879",
  "ui-addon-draggable-compat": "static-2.4368",
  "universal-record-utils-lib": "static-1.1229",
  "commerce-billing-lib": "static-1.19439",
  "commerce-shared-components-lib": "static-1.18796",
  "commerce-tools-ui-lib": "static-1.10666",
  "crm-fe-perf": "static-1.23012",
  "event-emitter": "static-1.1058",
  "bend-plugin-pulse": "static-1.207",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31425",
  "shared-worker-versioning": "static-1.11144",
  "calling-usage-tracker": "static-1.6651",
  "voice-sms-access-library": "static-1.1420",
  "commerce-permissions": "static-1.885",
  "products-iframe-lib": "static-1.8236",
  "products-ui-components-shared-msw-handlers": "static-1.10612",
  "data-agent-kit": "static-1.370",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10313",
  "policy-lib": "static-1.6890",
  "react-tinymce": "static-1.55530",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10376",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54656",
  "tinymce-plugins": "static-1.57770",
  "tinymce-themes": "static-1.56626",
  "onboarding-data-sync-lib": "static-1.2146",
  "growth-onboarding-next-action-components": "static-1.2266",
  "user-context-client": "static-1.4689",
  "audio-components": "static-1.6082",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37067",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4644",
  "video-components": "static-1.13634",
  "outpost": "static-1.4279",
  "growth-onboarding-feedback-components": "static-1.6687",
  "content-media-composition-data-lib": "static-1.12657",
  "content-media-compositions": "static-2.16664",
  "media-bridge-lib": "static-1.19113",
  "commerce-tours-lib": "static-1.6296",
  "growth-onboarding-reliability": "static-1.5189",
  "sales-checkout-service-client": "static-1.3702",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21865",
  "sales-email-signature-service-client": "static-1.3958",
  "ts-utils-lib": "static-1.281",
  "crm-export-dialog": "static-1.6393",
  "crm-index-associations-lib": "static-1.6550",
  "crm-view-components": "static-1.605",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7439",
  "nudge-custom-function-registry": "static-1.2563",
  "nudge-renderer-utils": "static-1.2882",
  "whisper-core-api": "static-1.6866",
  "InboxConnectUtils": "static-4.15096",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5785",
  "settings-content-modals": "static-1.46390",
  "crm_universal": "static-1.22197",
  "customer-data-email": "static-1.18226",
  "card-payment-highlight-lib": "static-1.37487",
  "card-subscription-highlight-lib": "static-1.39815",
  "commerce-contract-lib": "static-1.12591",
  "invoices-highlight-card-lib": "static-1.55088",
  "orders-highlight-card-lib": "static-1.21767",
  "products-highlight-card-lib": "static-1.18240",
  "quotes-highlight-card-lib": "static-1.72378",
  "crm-source-interpretation-lib": "static-1.5452",
  "crm-object-search-query-utilities": "static-1.9824",
  "utility-belt": "static-1.2641",
  "payments-enrollment-embed-lib": "static-1.23237",
  "stripe-embedded-components": "static-1.7699",
  "customer-data-rte": "static-1.33280",
  "cv-backend-services": "static-1.1558",
  "growth-onboarding-empty-states": "static-1.5938",
  "payments-post-enroll-local-storage-lib": "static-1.5215",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38468",
  "trials-service-types": "static-1.3991",
  "calling-orchestration-schema": "static-1.36197",
  "sales-views-client-types": "static-1.4364",
  "hub-http-contrib": "static-1.3152",
  "interframe": "static-3.4869",
  "tinymce-data": "static-1.40741",
  "ui-addon-sales-email": "static-1.5318",
  "layout-dnd-components": "static-1.12651",
  "layout-dnd-utils": "static-1.11626",
  "ui-brand-identity-lib": "static-1.15668",
  "NamespacedHubStyle": "static-2.9135",
  "meetings-connect-utils-lib": "static-1.7714",
  "social-insights-client-types": "static-1.22323",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4276",
  "checkout-sdk": "static-3.23917",
  "checkout-service-types": "static-1.3877",
  "company-details-components": "static-1.6306",
  "payment-method-components": "static-1.6981",
  "pricing-pages-ui-components": "static-1.14676",
  "quote-checkout-service-types": "static-1.3574",
  "upgrade-catalog-service-types": "static-1.3630",
  "access-control-lib": "static-1.10543",
  "EmailComponents": "static-1.55070",
  "EmailData": "static-1.53747",
  "redux-less": "static-2.9591",
  "sequences-lib": "static-1.8236",
  "ui-gdpr-components": "static-1.10458",
  "products-ui-components": "static-1.40475",
  "accounting-integrations-ui-components": "static-1.7240",
  "invoices-ui-lib": "static-1.55104",
  "commerce-products-api": "static-1.2455",
  "invoices-iframe-lib": "static-1.57162",
  "quotes-modal-lib": "static-1.103056",
  "quotes-ui-lib": "static-1.81099",
  "stripe-connect-js": "static-1.71",
  "draft-content-plugins": "static-1.28548",
  "ContentData": "static-1.68748",
  "layout-data-lib": "static-1.9951",
  "hub-http-rxjs": "static-1.809",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4046",
  "billing-payments-client-types": "static-1.4099",
  "react-performance-metrics-lib": "static-1.665",
  "account-and-billing-fintech-outages": "static-3.18713",
  "pricing-pages-api": "static-1.14541",
  "ContentComponents": "static-2.71629",
  "marketing-contacts-lib": "static-1.10408",
  "marketing-email-service-types": "static-1.1983",
  "messaging-editing-lib": "static-1.46579",
  "messaging-usage-based-billing-components-lib": "static-1.1441",
  "automation-ui-source-apps": "static-1.19198",
  "automation-ui-types": "static-1.20116",
  "messaging-types-lib": "static-1.46316",
  "onboarding-settings-client": "static-1.4612",
  "sequences-client-types-lib": "static-1.8093",
  "commerce-tax-lib": "static-1.644",
  "price-books-api": "static-1.1221",
  "price-books-components": "static-1.1279",
  "property-description-translator": "static-1.3949",
  "ramp-editor": "static-1.431",
  "commerce-analytics-service-client": "static-1.3690",
  "totals-ui-components": "static-1.23894",
  "SalesContentIndexUI": "static-3.9397",
  "advanced-menus-core": "static-1.15303",
  "advanced-menus-lib": "static-1.12216",
  "ui-memberships-settings-lib": "static-1.34339",
  "segments-query-core": "static-1.1529",
  "automation-ui-ubb": "static-1.6032",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7447",
  "data-token-views": "static-1.16578",
  "forms-utils-lib": "static-1.12784",
  "payments-embed-points-lib": "static-1.13254",
  "simple-menus-core": "static-1.15302",
  "simple-menus-lib": "static-1.16819",
  "videoconference-integration-components": "static-1.6974",
  "marketing-contacts-client": "static-1.7621",
  "automation-applications-service-types": "static-1.3594",
  "automation-platform-service-types": "static-1.2631",
  "ContentEditorUI": "static-2.77416",
  "short-messages-app-service-client": "static-1.4032",
  "web-interactives-components": "static-1.13949",
  "web-interactives-data": "static-1.13950",
  "messaging-shared-utils-lib": "static-1.890",
  "messaging-user-info-utils-lib": "static-1.1060",
  "email-portal-health-service-types": "static-1.1085",
  "line-items-api": "static-1.852",
  "commerce-totals-service-types": "static-1.3897",
  "FireAlarmUi": "static-1.4587",
  "sales-templates-service-types-lib": "static-1.4249",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22052",
  "automation-ui-usage-tracking": "static-1.21515",
  "data-studio-ubb": "static-1.3036",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27267",
  "collaboration-sidebar": "static-1.58170",
  "content-management-data-lib": "static-1.5591",
  "copilot-plugins": "static-1.11387",
  "cta-picker": "static-1.36685",
  "customer-agent-discovery-components-lib": "static-1.3395",
  "editor-components": "static-1.13384",
  "editor-iframe-lib": "static-1.8550",
  "error-messaging-js": "static-1.5300",
  "FormsCommonComponents": "static-1.86113",
  "pictos": "static-7.186",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10754",
  "SharedLegalStrings": "static-1.1854",
  "smart-content-core": "static-1.42735",
  "smart-content-lib": "static-1.43388",
  "social-composer-lib": "static-1.59547",
  "structured-content-lib": "static-1.25479",
  "theme-previewer-lib": "static-1.53539",
  "tinymce-copilot": "static-1.16724",
  "xray-recommendation-lib": "static-1.8046",
  "automation-ui-routing": "static-1.21473",
  "sql-reporting-client-types": "static-1.5724",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42428",
  "campaigns-utils-lib": "static-1.3299",
  "reporting-enablement": "static-1.23301",
  "chatspot-widget-iframe": "static-1.21801",
  "collaboration-sidebar-common": "static-1.2967",
  "forms-ai-lib": "static-1.4487",
  "codemirror-dlb": "static-1.58975",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6544",
  "report-customization-components": "static-1.13464",
  "data-quality-ui-library": "static-1.13315",
  "reporting-filters": "static-1.591",
  "reporting-insights-lib": "static-1.2067"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12719",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.479",
  "data-fetching-client": "/data-fetching-client/static-1.9771",
  "foundations-components": "/foundations-components/static-1.8144",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1169",
  "foundations-theming": "/foundations-theming/static-1.4538",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8128",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10230",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11584",
  "I18n": "/I18n/static-7.1637",
  "jasmine-runner": "/jasmine-runner/static-1.6567",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12782",
  "quartz": "/quartz/static-1.7165",
  "react-dlb": "/react-dlb/static-1.81",
  "react-rhumb": "/react-rhumb/static-1.16792",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2966",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9929",
  "settings-ui-lib": "/settings-ui-lib/static-1.12629",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7333",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11257",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9646",
  "unified-auth": "/unified-auth/static-1.621",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.903",
  "usage-tracker": "/usage-tracker/static-1.7457",
  "usage-tracker-core": "/usage-tracker-core/static-1.7307",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8203",
  "hub-http": "/hub-http/static-1.6331",
  "integrations-lib": "/integrations-lib/static-1.16509",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20142",
  "property-management-iframe": "/property-management-iframe/static-1.13533",
  "quartz-config": "/quartz-config/static-1.943",
  "quartz-core": "/quartz-core/static-1.6384",
  "quartz-routing": "/quartz-routing/static-1.595",
  "quick-fetch": "/quick-fetch/static-1.3997",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4764",
  "ts-schema": "/ts-schema/static-1.4159",
  "ui-universal-auth": "/ui-universal-auth/static-1.9107",
  "UIComponents": "/UIComponents/static-3.8530",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3477",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3442",
  "quartz-webpack": "/quartz-webpack/static-1.3389",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.243",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4413",
  "floating-ui": "/floating-ui/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4982",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2254",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9530",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.35",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5421",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2185",
  "ui-fonts": "/ui-fonts/static-1.846",
  "ui-images": "/ui-images/static-2.1180",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3021",
  "foundations-theming-base": "/foundations-theming-base/static-1.3523",
  "stylex": "/stylex/static-1.34",
  "HeadJS": "/HeadJS/static-2.768",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3239",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4434",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9226",
  "ai-rendering-library": "/ai-rendering-library/static-1.10560",
  "chirp-fetch": "/chirp-fetch/static-1.1995",
  "connections-embed-lib": "/connections-embed-lib/static-1.1195",
  "copilot-toolkit": "/copilot-toolkit/static-1.11414",
  "feedback-loader": "/feedback-loader/static-1.29499",
  "laboratory-lib": "/laboratory-lib/static-3.7261",
  "marketplace-embed": "/marketplace-embed/static-1.22439",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10037",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20097",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14312",
  "sanitize-text": "/sanitize-text/static-1.8253",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8811",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5871",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5143",
  "wootric-nps": "/wootric-nps/static-1.7062",
  "quartz-head": "/quartz-head/static-1.830",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4760",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4259",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2564",
  "reporting-data": "/reporting-data/static-1.67996",
  "cssUtils": "/cssUtils/static-1.823",
  "flux-actions": "/flux-actions/static-1.345",
  "HubStyle": "/HubStyle/static-2.11891",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10316",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10471",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7447",
  "icons": "/icons/static-2.653",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18674",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4620",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5627",
  "quartz-i18n": "/quartz-i18n/static-1.840",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.352",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.559",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.697",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.24",
  "slack-ui-library": "/slack-ui-library/static-1.10503",
  "fsm": "/fsm/static-1.3837",
  "customer-data-objects": "/customer-data-objects/static-1.7788",
  "property-translator": "/property-translator/static-1.5505",
  "hs-locale-management": "/hs-locale-management/static-1.161",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8036",
  "hs-promise-utils": "/hs-promise-utils/static-1.5700",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4986",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13924",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5715",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7891",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4584",
  "superstore": "/superstore/static-1.4868",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10337",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8057",
  "hub-http-janus": "/hub-http-janus/static-1.844",
  "hubspotter-http": "/hubspotter-http/static-1.4731",
  "immutable-less": "/immutable-less/static-1.4761",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17549",
  "nav-meta": "/nav-meta/static-1.29919",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18142",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3925",
  "property-management-common": "/property-management-common/static-1.5821",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9174",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.543",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.840",
  "quartz-test": "/quartz-test/static-1.840",
  "quartz-tracking": "/quartz-tracking/static-1.544",
  "trellis-components": "/trellis-components/static-1.2204",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.174",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21810",
  "ContentUtils": "/ContentUtils/static-1.68673",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13139",
  "sassPrefix": "/sassPrefix/static-1.158",
  "breeze-engine-core": "/breeze-engine-core/static-1.371",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.233",
  "avatar-components": "/avatar-components/static-1.2606",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40161",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13281",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14713",
  "ExportDialog": "/ExportDialog/static-6.10488",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41576",
  "reporting-snowflake": "/reporting-snowflake/static-1.56614",
  "reporting-ui-components": "/reporting-ui-components/static-2.65267",
  "reporting-visualizations": "/reporting-visualizations/static-1.60072",
  "trellis-theming": "/trellis-theming/static-1.1049",
  "ui-addon-teams": "/ui-addon-teams/static-1.21691",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.168",
  "magpie-lib": "/magpie-lib/static-1.5623",
  "navigation-components": "/navigation-components/static-1.18282",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1093",
  "magpie-types": "/magpie-types/static-1.5083",
  "simple-logging-lib": "/simple-logging-lib/static-1.3158",
  "ai-studio-lib": "/ai-studio-lib/static-1.11934",
  "app-governance-lib": "/app-governance-lib/static-1.1899",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10622",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8115",
  "ui-product-approvals": "/ui-product-approvals/static-1.28590",
  "ui-tool-access": "/ui-tool-access/static-1.10256",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9393",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5874",
  "usage-tracker-public": "/usage-tracker-public/static-1.7268",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3666",
  "persist-promise": "/persist-promise/static-1.3808",
  "reference-resolvers": "/reference-resolvers/static-1.8282",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4033",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.445",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3126",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3085",
  "atom": "/atom/static-1.5183",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6078",
  "salesImages": "/salesImages/static-1.527",
  "batch-promise": "/batch-promise/static-1.1651",
  "crm-component-utils": "/crm-component-utils/static-1.39373",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5997",
  "customer-data-properties": "/customer-data-properties/static-1.51955",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7001",
  "property-value-citations": "/property-value-citations/static-1.2569",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8207",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9172",
  "navigation-messaging": "/navigation-messaging/static-1.7609",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10228",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4923",
  "content-icons-ui": "/content-icons-ui/static-1.2257",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9934",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7356",
  "crm-message-bus": "/crm-message-bus/static-1.43270",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22596",
  "events-data-lib": "/events-data-lib/static-1.340",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4830",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4084",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6906",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1091",
  "onboarding-tours": "/onboarding-tours/static-1.16803",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13992",
  "academy-common-lib": "/academy-common-lib/static-1.14173",
  "content-assistance-lib": "/content-assistance-lib/static-1.7924",
  "dashboard-lib": "/dashboard-lib/static-1.81957",
  "file-manager-components": "/file-manager-components/static-1.23916",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18717",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18537",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18529",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20018",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8814",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4868",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11171",
  "user-context": "/user-context/static-1.5218",
  "growth-payments-core": "/growth-payments-core/static-1.25703",
  "reporting-plugins": "/reporting-plugins/static-1.10498",
  "reporting-reports": "/reporting-reports/static-1.67674",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.834",
  "nest": "/nest/static-1.341",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10736",
  "framework-listing-lib": "/framework-listing-lib/static-2.29004",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30972",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4362",
  "react-dnd-compat": "/react-dnd-compat/static-1.4724",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.485",
  "onboarding-scopes": "/onboarding-scopes/static-1.6569",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5017",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7752",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15059",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3669",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9582",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6081",
  "signup-constants": "/signup-constants/static-1.19103",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8166",
  "card-properties-lib": "/card-properties-lib/static-1.44525",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37392",
  "crm-actions": "/crm-actions/static-1.6448",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43909",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9557",
  "customer-data-tracking": "/customer-data-tracking/static-1.6997",
  "hs-resources": "/hs-resources/static-1.281",
  "pulse": "/pulse/static-1.704",
  "calling-global-api": "/calling-global-api/static-1.64890",
  "calling-internal-common": "/calling-internal-common/static-1.31418",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66272",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58566",
  "commerce-products-lib": "/commerce-products-lib/static-1.9957",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3875",
  "crm-links": "/crm-links/static-1.6416",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4217",
  "external-options-client-types": "/external-options-client-types/static-1.4208",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4296",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.742",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3770",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49123",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4046",
  "smart-property-lib": "/smart-property-lib/static-1.7761",
  "tiered-pricing": "/tiered-pricing/static-1.1497",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11098",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.120",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1149",
  "growth-data-modal": "/growth-data-modal/static-1.5599",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3174",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2238",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.869",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7718",
  "academy-service-client": "/academy-service-client/static-1.3792",
  "SafeStorage": "/SafeStorage/static-1.4508",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39415",
  "FileManagerLib": "/FileManagerLib/static-1.39556",
  "video-embed": "/video-embed/static-1.36124",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28864",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11632",
  "video-data-lib": "/video-data-lib/static-1.35290",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "payment-link-components": "/payment-link-components/static-1.23814",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9995",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24611",
  "viral-links-lib": "/viral-links-lib/static-1.7178",
  "data-token-picker": "/data-token-picker/static-1.16597",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.331",
  "timezone-utils": "/timezone-utils/static-2.5351",
  "seat-types-lib": "/seat-types-lib/static-1.266",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17835",
  "ui-addon-opt": "/ui-addon-opt/static-4.8470",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9421",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25667",
  "framework-data-table": "/framework-data-table/static-2.12162",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6974",
  "nudge-client-utils": "/nudge-client-utils/static-1.2806",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1216",
  "switchboard-lib": "/switchboard-lib/static-1.332",
  "app-users-service-client": "/app-users-service-client/static-1.5716",
  "app-users-service-types": "/app-users-service-types/static-1.5124",
  "mini-checkout-client": "/mini-checkout-client/static-1.27074",
  "onboarding-utils": "/onboarding-utils/static-1.5467",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2061",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28849",
  "edison-service-client-types": "/edison-service-client-types/static-1.498",
  "crm_data": "/crm_data/static-4.92307",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46316",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16879",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4368",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1229",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19439",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18796",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10666",
  "crm-fe-perf": "/crm-fe-perf/static-1.23012",
  "event-emitter": "/event-emitter/static-1.1058",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.207",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31425",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11144",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6651",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1420",
  "commerce-permissions": "/commerce-permissions/static-1.885",
  "products-iframe-lib": "/products-iframe-lib/static-1.8236",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10612",
  "data-agent-kit": "/data-agent-kit/static-1.370",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10313",
  "policy-lib": "/policy-lib/static-1.6890",
  "react-tinymce": "/react-tinymce/static-1.55530",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10376",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54656",
  "tinymce-plugins": "/tinymce-plugins/static-1.57770",
  "tinymce-themes": "/tinymce-themes/static-1.56626",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2146",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2266",
  "user-context-client": "/user-context-client/static-1.4689",
  "audio-components": "/audio-components/static-1.6082",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37067",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4644",
  "video-components": "/video-components/static-1.13634",
  "outpost": "/outpost/static-1.4279",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6687",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12657",
  "content-media-compositions": "/content-media-compositions/static-2.16664",
  "media-bridge-lib": "/media-bridge-lib/static-1.19113",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6296",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5189",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3702",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21865",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3958",
  "ts-utils-lib": "/ts-utils-lib/static-1.281",
  "crm-export-dialog": "/crm-export-dialog/static-1.6393",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6550",
  "crm-view-components": "/crm-view-components/static-1.605",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7439",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2563",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2882",
  "whisper-core-api": "/whisper-core-api/static-1.6866",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15096",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5785",
  "settings-content-modals": "/settings-content-modals/static-1.46390",
  "crm_universal": "/crm_universal/static-1.22197",
  "customer-data-email": "/customer-data-email/static-1.18226",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37487",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39815",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12591",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55088",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21767",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18240",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72378",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5452",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9824",
  "utility-belt": "/utility-belt/static-1.2641",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23237",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7699",
  "customer-data-rte": "/customer-data-rte/static-1.33280",
  "cv-backend-services": "/cv-backend-services/static-1.1558",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5938",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5215",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38468",
  "trials-service-types": "/trials-service-types/static-1.3991",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36197",
  "sales-views-client-types": "/sales-views-client-types/static-1.4364",
  "hub-http-contrib": "/hub-http-contrib/static-1.3152",
  "interframe": "/interframe/static-3.4869",
  "tinymce-data": "/tinymce-data/static-1.40741",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5318",
  "layout-dnd-components": "/layout-dnd-components/static-1.12651",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11626",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15668",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9135",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7714",
  "social-insights-client-types": "/social-insights-client-types/static-1.22323",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4276",
  "checkout-sdk": "/checkout-sdk/static-3.23917",
  "checkout-service-types": "/checkout-service-types/static-1.3877",
  "company-details-components": "/company-details-components/static-1.6306",
  "payment-method-components": "/payment-method-components/static-1.6981",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14676",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3574",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3630",
  "access-control-lib": "/access-control-lib/static-1.10543",
  "EmailComponents": "/EmailComponents/static-1.55070",
  "EmailData": "/EmailData/static-1.53747",
  "redux-less": "/redux-less/static-2.9591",
  "sequences-lib": "/sequences-lib/static-1.8236",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10458",
  "products-ui-components": "/products-ui-components/static-1.40475",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7240",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55104",
  "commerce-products-api": "/commerce-products-api/static-1.2455",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57162",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103056",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81099",
  "stripe-connect-js": "/stripe-connect-js/static-1.71",
  "draft-content-plugins": "/draft-content-plugins/static-1.28548",
  "ContentData": "/ContentData/static-1.68748",
  "layout-data-lib": "/layout-data-lib/static-1.9951",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.809",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4046",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4099",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.665",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18713",
  "pricing-pages-api": "/pricing-pages-api/static-1.14541",
  "ContentComponents": "/ContentComponents/static-2.71629",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10408",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1983",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46579",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1441",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19198",
  "automation-ui-types": "/automation-ui-types/static-1.20116",
  "messaging-types-lib": "/messaging-types-lib/static-1.46316",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4612",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8093",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.644",
  "price-books-api": "/price-books-api/static-1.1221",
  "price-books-components": "/price-books-components/static-1.1279",
  "property-description-translator": "/property-description-translator/static-1.3949",
  "ramp-editor": "/ramp-editor/static-1.431",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3690",
  "totals-ui-components": "/totals-ui-components/static-1.23894",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9397",
  "advanced-menus-core": "/advanced-menus-core/static-1.15303",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12216",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34339",
  "segments-query-core": "/segments-query-core/static-1.1529",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6032",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7447",
  "data-token-views": "/data-token-views/static-1.16578",
  "forms-utils-lib": "/forms-utils-lib/static-1.12784",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13254",
  "simple-menus-core": "/simple-menus-core/static-1.15302",
  "simple-menus-lib": "/simple-menus-lib/static-1.16819",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6974",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7621",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3594",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2631",
  "ContentEditorUI": "/ContentEditorUI/static-2.77416",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4032",
  "web-interactives-components": "/web-interactives-components/static-1.13949",
  "web-interactives-data": "/web-interactives-data/static-1.13950",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.890",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1060",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1085",
  "line-items-api": "/line-items-api/static-1.852",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3897",
  "FireAlarmUi": "/FireAlarmUi/static-1.4587",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4249",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22052",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21515",
  "data-studio-ubb": "/data-studio-ubb/static-1.3036",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27267",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58170",
  "content-management-data-lib": "/content-management-data-lib/static-1.5591",
  "copilot-plugins": "/copilot-plugins/static-1.11387",
  "cta-picker": "/cta-picker/static-1.36685",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3395",
  "editor-components": "/editor-components/static-1.13384",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8550",
  "error-messaging-js": "/error-messaging-js/static-1.5300",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86113",
  "pictos": "/pictos/static-7.186",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10754",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1854",
  "smart-content-core": "/smart-content-core/static-1.42735",
  "smart-content-lib": "/smart-content-lib/static-1.43388",
  "social-composer-lib": "/social-composer-lib/static-1.59547",
  "structured-content-lib": "/structured-content-lib/static-1.25479",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53539",
  "tinymce-copilot": "/tinymce-copilot/static-1.16724",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8046",
  "automation-ui-routing": "/automation-ui-routing/static-1.21473",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5724",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42428",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3299",
  "reporting-enablement": "/reporting-enablement/static-1.23301",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21801",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2967",
  "forms-ai-lib": "/forms-ai-lib/static-1.4487",
  "codemirror-dlb": "/codemirror-dlb/static-1.58975",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6544",
  "report-customization-components": "/report-customization-components/static-1.13464",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13315",
  "reporting-filters": "/reporting-filters/static-1.591",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2067"
}
};
